<template>
    <v-hover>
        <v-card flat tile slot-scope="{ hover }">
            <v-progress-circular :size="70" :width="7" v-if="loading" color="purple" indeterminate ></v-progress-circular>
            <v-btn @click="remove" fab fixed top right small color="black">
                <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-img v-hide="loading" :src="imgPath"></v-img>
        </v-card>
    </v-hover>
</template>
<script>
export default {
    props: ['imgKey'],
    data()  {
        return {
            loading: true,
            imgPath: null
        }
    },
    mounted () {
        let imgRef = this.$storage.ref().child('img').child(this.$System.currentUser.Negocio.id).child('productos').child(this.imgKey)
        if (imgRef.exists()) {
            this.imgPath = imgRef.getDownloadURL()
            this.loading = false
        }
    },
    methods: {
        remove () {
            //this.$emit('onDelete', {})
        }
    }
}
</script>